// const inputs = [
//   document.querySelector(".header-search__input"),
//   document.getElementById("ls-menu-search-input")
// ];
// const phrases = ["white dress", "white mini dress", "black dress"];
// let fixedText = "try search for...";
// let currentPhrase = "";
// let currentIndex = 0;
// let charIndex = 0;
// let isDeleting = false;

// function animatePlaceholder() {
//   if (isDeleting) {
//     currentPhrase = phrases[currentIndex].substring(0, charIndex--);
//   } else {
//     currentPhrase = phrases[currentIndex].substring(0, charIndex++);
//   }

//   inputs.forEach(input => {
//     if (input) {
//       input.setAttribute("placeholder", fixedText + currentPhrase);
//     }
//   });

//   if (!isDeleting && charIndex === phrases[currentIndex].length) {
//     // Почати видаляти текст, коли дійшли до кінця слова
//     isDeleting = true;
//     setTimeout(animatePlaceholder, 1000); // Пауза перед видаленням
//   } else if (isDeleting && charIndex === 0) {
//     // Перейти до наступної фрази, коли все видалено
//     isDeleting = false;
//     currentIndex = (currentIndex + 1) % phrases.length;
//     setTimeout(animatePlaceholder, 500); // Пауза перед наступним словом
//   } else {
//     // Встановлення швидкості друку чи видалення
//     setTimeout(animatePlaceholder, isDeleting ? 50 : 100);
//   }
// }

// animatePlaceholder();

const inputs = [
  document.querySelector(".header-search__input"),
  document.getElementById("ls-menu-search-input"),
  document.getElementById("ls-menu-search-mobile-input"),
  
];
const phrases = ["white dress", "white mini dress", "black dress"];
let fixedText = "try search for...";
let currentIndex = 0;
let charIndex = 0;
let isDeleting = false;
let typingSpeed = 100; // Швидкість друку
let deletingSpeed = 50; // Швидкість видалення
let pauseAtEnd = 1000; // Пауза в кінці фрази
let pauseAtStart = 500; // Пауза перед початком нової фрази

function animatePlaceholder() {
  // Змінюємо фразу залежно від стану (друкуємо чи видаляємо)
  const fullPhrase = phrases[currentIndex];

  if (isDeleting) {
    charIndex--;
  } else {
    charIndex++;
  }

  // Оновлюємо плейсхолдер
  const currentText = fullPhrase.substring(0, charIndex);
  inputs.forEach((input) => {
    if (input) {
      input.setAttribute("placeholder", fixedText + currentText);
    }
  });

  // Якщо текст завершено
  if (!isDeleting && charIndex === fullPhrase.length) {
    isDeleting = true;
    setTimeout(animatePlaceholder, pauseAtEnd); // Пауза перед видаленням
    return;
  }

  // Якщо видалення завершено
  if (isDeleting && charIndex === 0) {
    isDeleting = false;
    currentIndex = (currentIndex + 1) % phrases.length; // Переходимо до наступної фрази
    setTimeout(animatePlaceholder, pauseAtStart); // Пауза перед друком нової фрази
    return;
  }

  // Продовжуємо друк або видалення
  const delay = isDeleting ? deletingSpeed : typingSpeed;
  setTimeout(animatePlaceholder, delay);
}

// Запускаємо анімацію
animatePlaceholder();
